import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import cn from 'classnames';
import { CompanyFilter } from './CompanyFilter';
import { FiltersCloud } from './CompanyFiltersCloud';
import { CompaniesearchText } from './SearchText';
import { selectCompanyFilter, selectCountries } from '../selectors';
import { applyCompanyFilter, resetCompanyFilter } from '../actions';
import { COLOR_BG_LIGHT } from '../../../vars';
import styles from './Search.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../translate-countries';
import { HBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';

const Container = styled.div`
  float: left;
  width: 100%;

  & * .Dropdown-root {
    width: 100%;
  }

  .filters-rows {
    gap: 12px;
    padding: 0px 24px 24px 24px;
    background-color: white;
    // margin-bottom: 22px;
    @media (max-width: 768px) {
      max-width: 100%;
      padding: 15px;
    }
  }

  .form-control {
    margin-bottom: 0;
  }


   .fw-light {
    font-size: 12px !important;
    font-weight: 400 !important;
    font-family: Poppins, sans-serif !important;
    padding-left: 10px !important;
    color: #808080 !important;
  }

  @media (max-width: 767.98px) {
  .fw-light {
    font-size: 14px !important;
  }
}

  .button {
    width: auto;
  }

  .all-filters-block {
    padding: 10px;
    background-color: ${COLOR_BG_LIGHT};
  }

  .button-filter {
    padding-right: ${props => props.width > 500 && '24px'};
    & * .button {
      margin: 0px;
      margin-left: 12px;
      background-color: white;
      color: #808c9c;
      border-radius: 8px 8px 0px 0px;
      box-shadow: 0 -2px 6px -1px #ececef;
      &:hover {
        background-color: #0183d5;
        color: #fff;
        box-shadow: none;
      }
    }
  }

  .row-1 {
    & * .decorated {
      width: 100%;
    }
  }

  .grid-column {
  }

  .grid-row-long {
    flex-basis: ${props => (props.width <= 2200 ? '100%' : '49%')};
  }
  .grid-row-short {
    /* border: 1px solid #cccccc; */
    border-radius: 3px;
    flex-basis: 49%;
    & > .button {
      margin: 0px;
    }
  }

  .tablet-row {
    margin-bottom: 22px;
    @media (max-width: 500px) {
      flex-direction: column;
      gap: 8px;
    }
  }

  .row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .button-block {
    & * .button {
      margin: 0px;
    }
  }
  .input-element {
    font-size: 13px;
    height: 45px;
  }
`;

const STATE = {
  showAllFilters: false,
  filterToReset: null,
};
/* eslint-disable react/prefer-stateless-function */
class CompaniesearchComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  get optionsCompanyType() {
    return ['company', 'individual'];
  }

  get statuses() {
    let statuses = _.times(6, n => {
      return this.lblStr(`company.property.status.${n}`);
    })?.map(s => `${s}`);

    return statuses;
  }

  get optionsCompanyFrom() {
    return ['nl', 'eu', 'outside_eu'];
  }

  get optionsCountryId() {
    let options = this.props.countries.map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }));
    return options;
  }

  get locale() {
    return this.props.locale;
  }

  toggleFiltersView = () => {
    this.setState(state => ({ showAllFilters: !state.showAllFilters }));
  };

  resetFilter = name => {
    this.setState({ filterToReset: name });
  };

  render() {
    if (!this.props.filter) return null;
    const STATUSES = this.statuses;

    return (
      <Container className="filter-container">
      <div className="container-fluid p-0">
          <div className="row align-items-center">
              <div className="col-6 col-md-3">
                  <CompaniesearchText filter={this.props.filter} overviewPage />
              </div>
              <div className="col-6 col-md-3">
                  <CompanyFilter
                      controlWidth={'100%'}
                      name="company_type"
                      type="single"
                      options={this.optionsCompanyType}
                  />
              </div>
              <div className="col-6 col-md-3">
                  <CompanyFilter
                      controlWidth={'100%'}
                      name="company_from_eu"
                      type="single"
                      options={this.optionsCompanyFrom}
                  />
              </div>
              <div className="col-6 col-md-3">
                  <CompanyFilter
                      controlWidth={'100%'}
                      name="countryId"
                      type="multiple"
                      options={this.optionsCountryId}
                      noModify
                  />
              </div>
          </div>
  
          <div className="row align-items-center">
              <div className="col-6 col-md-3">
                  <CompanyFilter
                      controlWidth={'100%'}
                      name="status"
                      type="multiple"
                      options={STATUSES}
                  />
              </div>
              <div className="col-6 col-md-3">
                  <CompanyFilter
                      controlWidth={'100%'}
                      name="account_manager_user_id"
                      type="single"
                      userId
                  />
              </div>
              <div className="col-6 col-md-3">
                  <CompanyFilter
                      controlWidth={'100%'}
                      name="has_ordered"
                      type="single"
                      inversed
                      isBool
                  />
              </div>
              <div className="col-6 col-md-3">
                  <CompanyFilter
                      controlWidth={'100%'}
                      name="has_incoming_order"
                      type="single"
                      inversed
                      isBool
                  />
              </div>
          </div>
  
          <div className="row p-0 mt-2 align-items-center">
  <div className="col">
    <FiltersCloud />
  </div>
  <div className="col-auto">
    <ButtonComponent style={'ButtonSoftEdit'} onClick={() => this.props.applyFilters()}>
      {this.lblStr('vehicle.filter.apply')}
    </ButtonComponent>
  </div>
</div>
      </div>
  </Container>
  
    );
  }
}

CompaniesearchComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    countries: selectCountries(),
    filter: selectCompanyFilter(),
    locale: makeSelectLocale(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset() {
      dispatch(resetCompanyFilter());
    },
    applyFilters() {
      dispatch(applyCompanyFilter());
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const Companiesearch = compose(withConnect, withRouter, injectIntl)(CompaniesearchComp);
